import { useContext } from 'react'
import { CompanyContext } from 'contexts/CompanyContextProvider'

export function useCompanyId() {
  const { company } = useContext(CompanyContext)
  return company.id
}